<ng-container *ngIf="!isLoadingLabels">
	<div
		class="search-filter-container"
		*ngIf="(availableFiltersIAC && availableFiltersIAC.length > 0) || (selectedFiltersGeneric && selectedFiltersGeneric.length > 0)">
		<div class="title">{{ labels[titleLabel] ? labels[titleLabel] : titleLabel }}</div>

		<div class="tags-container">
			<div class="tag" *ngIf="selectedFiltersGeneric && selectedFiltersGeneric.length === 0">
				{{ labels.lbl_nenhum_filtro_selecionado }}
			</div>
			<div
				class="tag"
				(click)="tag.undeletable ? null : deleteTag(index)"
				*ngFor="let tag of selectedFiltersGeneric; let index = index">
				<span>{{ tag.label && labels[tag.label] ? labels[tag.label] : tag.name }}</span>
				<span *ngIf="!tag.undeletable"><fa-icon [icon]="icons.faTimes"></fa-icon></span>
			</div>
		</div>
		<cpi-input-with-autocomplete
			[availableOptions]="availableFiltersIAC"
			[placeholder]="labels.lbl_geral_selecione"
			[minInputLength]="0"
			[inputHeight]="'30px'"
			[keepValue]="false"
			(onValueChange)="setTag($event)"
			(setValue)="(null)">
		</cpi-input-with-autocomplete>

		<div class="tip mb-2">{{ labels[tipLabel] ? labels[tipLabel] : tipLabel }}</div>

		<cpi-generic-form-gen
			[setGenericForm]="selectedFiltersGeneric"
			[periodDatePeriodOnly]="false"
			(valueTap)="emitSelectedFilters()"
			[boldLabel]="false"
			[labels]="labels">
		</cpi-generic-form-gen>
	</div>
</ng-container>

<cpi-dot-bounce-loading-effect class="mt-2" [color]="'var(--primary-color-2)'" *ngIf="isLoadingLabels"></cpi-dot-bounce-loading-effect>
